import { HStack, VStack, Button, Text } from '@cad-arc';
import { UnitStatusSearchForm, UnitStatusSearchRow } from '@mark43/cad-api';
import { globalAttributes } from '../common/global-attributes';
import { ExpandableContent } from './expandable-content';
import { FR_EVENT_DETAILS_TABS } from '../fr-event-details-page/constants';
import { UNIT_STATUS_SEARCH_WINDOW_PATH } from '../router/constants';
import { useOpenEvent } from '../common/hooks/use-open-event';
import { PriorityCaution } from '../common/components/priority-caution';

export function UnitStatusSearchResultsEventDetailsCell({
    row,
    isExpanded,
    searchData,
}: Readonly<{
    row: UnitStatusSearchRow;
    isExpanded: boolean;
    searchData?: UnitStatusSearchForm;
}>) {
    const locationState = {
        previousLocationPathname: UNIT_STATUS_SEARCH_WINDOW_PATH,
        unitStatusSearchResults: searchData,
    };

    const handleOpenEvent = useOpenEvent();

    if (!row.eventNumber || !row.eventId) {
        return null;
    }

    const isPriority1 =
        row.eventPriorityGlobalAttrId === globalAttributes.cfsPriorityGlobal.CFS_PRIORITY_1;

    return (
        <VStack align="left" gap={isExpanded ? '16px' : undefined} maxW="245px">
            <VStack align="left">
                <HStack>
                    {row.eventPriority && (
                        <PriorityCaution
                            label={row.eventPriority}
                            priorityAttrId={row.eventPriorityAttrId}
                            agencyTypeGlobalAttrId={row.eventAgencyTypeGlobalAttrId}
                            isPriority1={isPriority1}
                        />
                    )}
                    <Button
                        variant="ghost"
                        trailingVisual="OpenNewWindow"
                        onClick={() =>
                            handleOpenEvent({
                                eventId: row.eventId,
                                frEventDetailsTabName: FR_EVENT_DETAILS_TABS.NARRATIVE,
                                locationState,
                            })
                        }
                    >
                        {row.eventNumber}
                    </Button>
                </HStack>
                <ExpandableContent isExpanded={isExpanded}>
                    {row.eventCallForService && <Text>{row.eventCallForService}</Text>}
                </ExpandableContent>
            </VStack>
            <ExpandableContent isExpanded={isExpanded}>
                {row.eventNarrative && (
                    <Text
                        isItalic={true}
                        style={{
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            overflowWrap: 'break-word',
                        }}
                    >
                        {row.eventNarrative}
                    </Text>
                )}
            </ExpandableContent>
        </VStack>
    );
}
